'use client';

import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { PdpInfoDTO } from '@/types/models';
import { convertNumberToFormatted } from '@/utils/function';
interface InvestmentStatusProps {
  data: PdpInfoDTO;
}
const InvestmentStatusDetails = ({
  data
}: InvestmentStatusProps): JSX.Element => {
  const texts = {
    title: 'سرمایه تأمین شده',
    desc1: 'حداقل سرمایه مورد نیاز اجرای طرح:',
    finish: 'تأمین شد',
    preValue: 'تومان',
    profitPerMonth: 'نحوه پرداخت سود',
    descriptionResult: `  هر ${data.profitPerMonth} ماه - ${data.percentPerMonth || 0}% `
  };
  return <Box sx={{
    width: '100%'
  }} data-sentry-element="Box" data-sentry-component="InvestmentStatusDetails" data-sentry-source-file="InvestmentStatusDetails.tsx">
      <Typography sx={{
      display: 'block',
      width: '100%',
      pt: 'var(--spacing_xxs_nudge)',
      textAlign: 'center'
    }} variant='captionLight__Wallfund' data-sentry-element="Typography" data-sentry-source-file="InvestmentStatusDetails.tsx">
        <Typography color='text.text2' variant='captionLight__Wallfund' data-sentry-element="Typography" data-sentry-source-file="InvestmentStatusDetails.tsx">
          {texts.desc1}{' '}
        </Typography>
        <Typography color='text.text' variant='captionStrong__Wallfund' data-sentry-element="Typography" data-sentry-source-file="InvestmentStatusDetails.tsx">
          {convertNumberToFormatted((data?.minInvestment || 0)?.toString())}{' '}
        </Typography>
        <Typography color='text.text2' variant='captionLight__Wallfund' data-sentry-element="Typography" data-sentry-source-file="InvestmentStatusDetails.tsx">
          {texts.preValue}
          {'   '}
        </Typography>
        {+data.providedFund > +data.minInvestment && <Typography color='approve.text' variant='bodyStrong__Wallfund' px={0.2}>
            {texts.finish}
          </Typography>}{' '}
      </Typography>

      <Box sx={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      pt: 'var(--spacing_m)'
    }} data-sentry-element="Box" data-sentry-source-file="InvestmentStatusDetails.tsx">
        <Typography variant='captionRegular__Wallfund' color={'text.text2'} data-sentry-element="Typography" data-sentry-source-file="InvestmentStatusDetails.tsx">
          {texts.profitPerMonth}{' '}
        </Typography>

        <Typography color='text.text' variant='bodyStrong__Wallfund' data-sentry-element="Typography" data-sentry-source-file="InvestmentStatusDetails.tsx">
          {texts.descriptionResult}
        </Typography>
      </Box>
    </Box>;
};
export default InvestmentStatusDetails;